//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


const NAME = "Logistics";
import baseUrlApi from '../../api/api.js'
export default {
  name: NAME,
  components: {

  },
  data() {
    return {
      id: this.$route.query.reqsn,
      amount: this.$route.params.amount,
      count: this.$route.params.count,
      payAmount:this.$route.query.trxamt/100,
      payOrderNumber:'',
      orderStatus:'',

    };
  },
  created() {
    console.log("12313",this.$route)
    let str = window.location.href;

    //this.str = window.location.href;
    //this.getPayResultW();
  },

  mounted() {
    let mchData ={action:'onIframeReady',displayStyle:'SHOW_CUSTOM_PAGE',height:700}
    let postData = JSON. stringify(mchData)
    parent.postMessage(postData,'https://payapp.weixin.qq.com')

  },
  methods: {
    gohome() {
      let mchData = {
        action: "jumpOut",
        jumpOutUrl: baseUrlApi.baeurlWeb+"/#/wx/home" //跳转的页面
      };
      var postData = JSON.stringify(mchData);
      parent.postMessage(postData, "https://payapp.weixin.qq.com");
    },
    goDetail() {
      let mchData = {
        action: "jumpOut",
        jumpOutUrl: baseUrlApi.baeurlWeb+"/#/WeChat/payRecord" //跳转的页面
      };
      var postData = JSON.stringify(mchData);
      parent.postMessage(postData, "https://payapp.weixin.qq.com");
    },
    getPayResultW: async function(){
      this.payShow=false
      const _this=this;
      let params = {
        terminalType:2,
        reqsn:this.$route.query.reqsn,
        token:this.$cookies.get('wxToken')
      };
      console.log(params);
      const response = await this.$api.post("/wxMp/payOrderQuery", params);
      console.log('微信支付结果查询',response)
      if(response.data.code=='0000'){

        _this.orderStatus=response.data.data.orderStatus
        _this.payOrderNumber=response.data.data.payOrderNumber
        _this.payAmount=response.data.data.payAmount/100

      }
      else{
        _this.$vux.toast.show({
          text: response.data.msg,
          type: "warn",
          time:'5000'
        })
      }
    },
  }
};



// WEBPACK FOOTER //
// ./src/views/wx/resultPay.vue